// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version-container {
    position: fixed;
    right: 0;
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    width: fit-content;
    padding: 15px;
    margin-top: 8px;
    margin-right: 8px;
}

.version-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.version-label {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.version-dropdown {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: #f9f9f9;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 6px 30px 6px 10px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
}

.version-dropdown:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.version-info {
    font-size: 12px;
    color: #6b7280;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.version-info span {
    font-weight: 500;
    color: #4b5563;
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/VersionsSelect.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,WAAW;IACX,eAAe;IACf,yDAAiS;IACjS,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".version-container {\n    position: fixed;\n    right: 0;\n    background-color: white;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    width: fit-content;\n    padding: 15px;\n    margin-top: 8px;\n    margin-right: 8px;\n}\n\n.version-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.version-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n}\n\n.version-dropdown {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-color: #f9f9f9;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    padding: 6px 30px 6px 10px;\n    font-size: 13px;\n    color: #333;\n    cursor: pointer;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n}\n\n.version-dropdown:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n.version-info {\n    font-size: 12px;\n    color: #6b7280;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.version-info span {\n    font-weight: 500;\n    color: #4b5563;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
